import { useTranslation } from "react-i18next"

import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import { DocumentsList } from "@/features/documents/components/documents-list"
import { deliveryFormKeys, useDeliveryFormDocuments } from "@/features/delivery-forms/hooks/use-delivery-form"
import { resolveApiError } from "@/lib/api/error-i18n"

interface DeliveryDocumentsTabProps {
  deliveryFormId: number
}

export function DeliveryDocumentsTab({
  deliveryFormId,
}: DeliveryDocumentsTabProps) {
  const { t } = useTranslation(["documents", "common"])
  const query = useDeliveryFormDocuments(deliveryFormId)

  if (query.isLoading) {
    return (
      <Card>
        <CardContent className="space-y-3 py-6">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </CardContent>
      </Card>
    )
  }

  if (query.isError) {
    return (
      <Card>
        <CardContent className="py-6">
          <p className="text-sm text-muted-foreground">
            {resolveApiError(query.error, t)}
          </p>
        </CardContent>
      </Card>
    )
  }

  return (
    <DocumentsList
      documents={query.data}
      level="delivery"
      deliveryId={String(deliveryFormId)}
      invalidateKeys={[deliveryFormKeys.documents(deliveryFormId)]}
    />
  )
}
